import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import styles from './styles.module.scss';

import apiProductCMS from '../../api/Product';
import apiLogin from '../../api/Login';
import ApiProduct from '../../api/Product/Product';

import Breadcrumb from '../../components/Product/Breadcrumb';
import ProductInfo from '../../components/Product/Info';
import ImagePlaceholder from '../../components/Placeholder';

import Config, { spanish } from '../../config/config';

import placeholderMobile from '../../assets/placeholder/product-mobile.jpg';
import placeholderDesktop from '../../assets/placeholder/product-desktop.jpg';

const ProductPage = () => {
  const history = useHistory();
  const sku = history.location.state?.sku;
  const estadoId = useSelector(
    (globalState) => globalState.estadoSelection.selectedEstadoId
  );
  const [cmsContent, setCmsContent] = useState(null);
  const [productInfoApi, setProductInfoAPI] = useState([]);
  const [cmsData, setCmsData] = useState(null);
  const [login, setLogin] = useState(null);

  const slug = history.location.pathname.replace(/\/.*\//, '');
  const productID = sku !== undefined ? sku : slug;

  const getProductById = useCallback(async (estadoIdParam) => {
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      IdProducto: productID,
      IdEstado: estadoIdParam,
    };
    try {
      const resp = await ApiProduct.getProductById(payload);
      if (resp.Codigo === 200) {
        setProductInfoAPI(resp.ListaProductos[0]);
      }
    } catch (error) {
      console.log(error);
    }
  });

  useEffect(async () => {
    setCmsContent(await apiProductCMS.getContent());
    setCmsData(await apiProductCMS.getSKU(productID));
    setLogin(await apiLogin.getLogin());
    getProductById(estadoId);
  }, [sku, estadoId]);

  return (
    <div className={styles.container}>
      {login && cmsContent && cmsData && cmsData[0] && productID ? (
        <>
          <Helmet
            title={cmsData[0]?.Name}
            meta={[
              {
                name: 'description',
                content: spanish
                  ? cmsData[0]?.IntroSpanish
                  : cmsData[0]?.IntroEnglish,
              },
            ]}
          />
          <Breadcrumb cmsData={cmsData[0]} spanish={spanish} />
          <ProductInfo
            productInfoApi={productInfoApi}
            spanish={spanish}
            login={login}
            content={cmsContent}
            cmsData={cmsData[0]}
          />
        </>
      ) : (
        <ImagePlaceholder
          mobile={placeholderMobile}
          desktop={placeholderDesktop}
        />
      )}
    </div>
  );
};

export default ProductPage;
